<template>
  <v-dialog id="dialog" v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" text class="primary--text">
        <v-icon small class="mr-1">mdi-cloud</v-icon>
        Provision Cloud VM
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Provision Cloud Instance</v-card-title>
      <v-card-text>
        <v-container fluid v-if="registrationTokens.length > 0">
          <v-row align="center">
            <v-select
              class="pr-4"
              :items="registrationTokens"
              label="Registration Token"
              v-model="selectedTokenID"
              :hint="`used by ${selectedToken.deviceCount} devices`"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-row>

          <v-row>
            <p>
              Add the following commands as a 
              <a href="https://cloudinit.readthedocs.io/en/latest/index.html" target="_blank" rel="noopener">Cloud-Init</a> 
              script to the cloud instance that you would like to add to Synpse. The script will download, install and
              securely configures the Synpse agent:
            </p>
          
          </v-row>

          <v-row align="center" class="mb-2 mt-4">
            <markup language="bash" :code="installCommand" :inline="false"></markup>
          </v-row>

          <v-row align="center" class="mt-4">            
              All major cloud providers support Cloud-Init, you can find more in their docs:            
          </v-row>
          <v-row align="center">
            <v-list dense>
              <v-list-item v-for="provider in cloudProviders" :key="provider.name">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ provider.name}} - <a :href="provider.url" target="_blank" rel="noopener">docs</a>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          
          </v-row>

        </v-container>

        <v-container fluid v-else >
          <v-row align="center">
            <pre>
              Please create at least one device registration token before provisioning.
            </pre>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text v-on:click.native="dialog = false" class="primary">Close</v-btn>
        <v-spacer></v-spacer>  
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="stylus">
  .addbtn
    margin: 0px
    top: auto
    right: 20px
    bottom: 20px
    left: auto
    position: fixed
    z-index: 1
</style>

<script>
import Markup from '../helpers/Markup';

  export default {
    components: {
      Markup
    },
    data () {
      return {
        dialog: false,

        selectedTokenID: '',

        cloudProviders: [
          {
            name: 'Google Cloud Platform',
            url: 'https://cloud.google.com/container-optimized-os/docs/how-to/create-configure-instance#using_cloud-init_with_the_cloud_config_format'
          },
          {
            name: 'Amazon AWS',
            url: 'https://docs.aws.amazon.com/AWSEC2/latest/UserGuide/user-data.html'
          },
          {
            name: 'Microsoft Azure',
            url: 'https://learn.microsoft.com/en-us/azure/virtual-machines/linux/cloudinit-bash-script'
          },
          {
            name: 'Vultr',
            url: 'https://www.vultr.com/docs/how-to-deploy-a-vultr-server-with-cloudinit-userdata/#Advantages_of_cloud_init'
          }
        ]
      }
    },

    computed: {
      loading() {
        return this.$store.state.device.loading
      },
      error() {
        return this.$store.state.device.error
      },
      projectId() {
        return this.$route.params.project
      },
      registrationTokens() {
        return this.$store.state.device.registrationTokens
      },
      selectedToken() {
        if (this.selectedTokenID === '' && this.registrationTokens.length > 0) {
          return this.registrationTokens[0]
        } 
        const selectedTokenId = this.selectedTokenID
        const found = this.registrationTokens.find(token => token.id === selectedTokenId)
        return found
      },    
      installCommand() {
        // some crappy formatting
        return `#!/bin/sh

curl https://downloads.synpse.net/install.sh | \\\n  AGENT_PROJECT=${this.projectId} \\\n  AGENT_REGISTRATION_TOKEN=${this.selectedToken.id} \\\n  AGENT_CONTROLLER_URI=${window.location.protocol}//${window.location.host}/api \\\n  bash`
      }
    },

    methods: {
      refresh () {
        let q = {
          projectId: this.projectId
        } 
        this.$store.dispatch('ListDeviceRegistrationTokens', q)
      }
    }
  }
</script>
